import React from 'react'

import { ErrorOutline, InfoOutline } from '../../../icons'
import { SpaceProps } from '../../../themes'
import { Container, IconWrapper, Message, Row } from './styles'
import type { MessageType } from './types'

export interface FieldMessagesProps extends SpaceProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Message type
   */
  type?: MessageType

  /**
   * Icon to display before the error message
   */
  icon?: React.ReactNode

  /**
   * Error messages
   */
  messages?: string | string[]
}

const getIcon = (type: MessageType, icon?: React.ReactNode) => {
  if (icon) return icon

  switch (type) {
    case 'error':
      return <ErrorOutline />
    case 'caption':
      return <InfoOutline />
    default:
      return null
  }
}

export const FieldMessages = ({
  className,
  type = 'error',
  icon,
  messages,
  ...spaceProps
}: FieldMessagesProps) => {
  const displayIcon = getIcon(type, icon)
  const messageList = messages
    ? Array.isArray(messages)
      ? messages
      : [messages]
    : []
  const hasMessages = messageList.length > 0

  return hasMessages ? (
    <Container className={className} type={type} {...spaceProps}>
      {messageList.map((errorMessage, i) => (
        <Row key={i}>
          {displayIcon && <IconWrapper>{displayIcon}</IconWrapper>}
          <Message>{errorMessage}</Message>
        </Row>
      ))}
    </Container>
  ) : null
}
